import { useEffect, useRef, useState } from "react";
import { getFirestore, addDoc, collection } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { Link, NavLink } from "react-router-dom";
//import { getAnalytics } from "firebase/analytics";

const chunkSize = 1024 * 1023;

const HomePage = (props) => {
  /*
  const uploadRef = useRef();
  const [db, setDb] = useState();

  useEffect(() => {
    const firebaseConfig = {
      apiKey: "AIzaSyBAzmjh3Z42oqs71ZcKg7bIweOLA4ZknBI",
      authDomain: "grouptools-2a0ac.firebaseapp.com",
      projectId: "grouptools-2a0ac",
      storageBucket: "grouptools-2a0ac.firebasestorage.app",
      messagingSenderId: "922629922979",
      appId: "1:922629922979:web:d4acafcacd071e1908df16",
      measurementId: "G-2W55WFWL8R",
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    //const analytics = getAnalytics(app);
    const db = getFirestore(app);
    setDb(db);
  }, []);

  let ps = [];
  for (let i = 0; i < 25; i++) {
    ps.push(
      <p>
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum."
      </p>
    );
  }

  const handleFiles = (e) => {
    const db = getFirestore();
    const fileCollectionRef = collection(db, "files");
    const chunkCollectionRef = collection(db, "chunks");

    console.log(e.target.files);
    for (const file of e.target.files) {
      addDoc(fileCollectionRef, {
        file_name: file.name,
        file_modified: file.lastModified,
        file_size: file.size,
        file_type: file.type,
      }).then((docRef) => {
        const file_id = docRef.id;

        const reader = new FileReader();
        reader.onload = (e) => {
          const base64String = e.target.result;
          const dataLength = base64String.length;
          const chunkCount = Math.ceil(dataLength / chunkSize);

          for (let chunkNum = 0; chunkNum < chunkCount; chunkNum++) {
            const startIndex = chunkNum * chunkSize;
            const endIndex =
              chunkNum === chunkCount - 1
                ? dataLength
                : (chunkNum + 1) * chunkSize;

            console.log(startIndex, endIndex);
            addDoc(chunkCollectionRef, {
              file_id: file_id,
              chunk_size: endIndex - startIndex,
              chunk_num: chunkNum,
              chunk_data: base64String.slice(startIndex, endIndex),
            }).then(() => {
              console.log(`Finished uploading chunk ${chunkNum}`);
            });
          }
          //uploadRef.current.value = null;
        };
        reader.addEventListener("progress", (e) => {
          console.log(e.loaded, e.total, (e.loaded / e.total) * 100);
        });
        reader.readAsDataURL(file);
      });
    }
  };
*/
  return (
    <div style={{ width: "90%", marginLeft: "auto", marginRight: "auto" }}>
      {/*
        <h1>Share</h1>
        <input
          class="form-control"
          type="file"
          name="files"
          ref={uploadRef}
          onChange={handleFiles}
          multiple
        />
        <btn class="btn btn-secondary">Select</btn>
        <btn class="btn btn-success">Share</btn>
        {ps.map((element) => {
          return element;
        })}
        
        
        */}
      <br />
      <h1>Welcome</h1>
      <Link className="btn btn-secondary" to="/voting">
        Vote for Winners!
      </Link>
      &nbsp;
      <Link className="btn btn-secondary" to="/team">
        Register Your Team
      </Link>
    </div>
  );
};

export { HomePage };
